module.exports = __webpack_public_path__ + "static/media/creatine.383cf884.png";